import { render, staticRenderFns } from "./customersai.vue?vue&type=template&id=4b6b6a50&scoped=true&"
import script from "./customersai.vue?vue&type=script&lang=js&"
export * from "./customersai.vue?vue&type=script&lang=js&"
import style0 from "./customersai.vue?vue&type=style&index=0&id=4b6b6a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b6a50",
  null
  
)

export default component.exports